import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const FabricadoPisoCaucho = () => {
  return (
    <section className="pb-lg-22">
      <div className="container">
        <div className="row align-items-center mt-n1-6 mt-sm-n6">
          <div className="col-lg-5 mt-1-6 mt-sm-6">
            <div className="position-relative text-center text-lg-start">
              <img 
                src="/assets/img/productos/piso-caucho-reciclado/piso-de-caucho-fabricado.jpg" 
                alt="piso de caucho fabricado con material reciclado" 
              />
              <div className="position-absolute bottom-n10 right-n10 right-lg-n30 d-none d-sm-block">
                <img 
                  src="/assets/img/productos/piso-caucho-reciclado/piso-de-caucho-fabricado-small.jpg" 
                  alt="piso de caucho fabricado con material reciclado" 
                  style={{ width: '300px', height: '300px' }} 
                />
              </div>
            </div>
          </div>
          <div className="col-lg-7 mt-1-6 mt-sm-6">
            <div className="ps-lg-2-9 ps-xl-10">
              <div className="mb-1-9 mb-xl-8">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">Contamos con entrega inmediata</span>
                <h2 className="mb-1-6 display-5 font-weight-800 lh-1">¿Cómo está fabricado el Piso de Caucho?</h2>
              </div>
              <div className="ps-1-9 ps-sm-10 ps-lg-20">
                <p className="mb-1-6 mb-sm-2-2">
                El Piso de Caucho está elaborado con materiales reciclados, específicamente hule de llantas triturado y aglutinado con resina de poliuretano. Esta composición le proporciona una alta durabilidad, ideal para soportar uso rudo y resistir cambios climáticos. 
                <br></br>
                Además de su funcionalidad, es una opción atractiva desde el punto de vista ecológico, ya que contribuye a la reducción de residuos y fomenta la reutilización de materiales, disminuyendo el impacto ambiental. 
                <br></br>
                Este piso es perfecto para gimnasios, áreas de juego y espacios deportivos, ofreciendo una solución sostenible y de alto rendimiento.
                </p>
                <a href="contacto-decototal" className="butn-style4 secondary"><span>Cotiza con nosotros</span></a>
                <div className="w-xl-100 w-xxl-100 mb-6">
                  <BannerNoInstalacion />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FabricadoPisoCaucho;
